import {useMutation, useQueryClient} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {httpRetryExport} from '@/features/exports/http/exports.http'
import {patchExportInCache} from '@/features/exports/query/exportsCache'
import {errorHandler} from '@/utilities/helpers'

/**
 * Retry a failed export job. Creates a NEW pending job (the original stays failed);
 * the new job is inserted into the cached lists (FR-017). 409 EXPORT_NOT_RETRYABLE is
 * surfaced via the shared error handler.
 */
export const useRetryExport = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: [MUTATION_KEYS.RETRY_EXPORT],
        mutationFn: (id: string) => httpRetryExport(id),
        onSuccess: job => {
            patchExportInCache(queryClient, job)
        },
        onError: errorHandler
    })
}
